import feathers from '@feathersjs/feathers';
import auth from '@feathersjs/authentication-client';
import rest from '@feathersjs/rest-client';
import axios from 'axios';

import { SERVER_URL } from 'config/constants';

const restClient = rest(SERVER_URL);

const feathersClient = feathers()
  .configure(restClient.axios(axios.create({ headers: { 'Access-Control-Allow-Origin': '*' } })))
  .configure(
    auth({
      storageKey: 'MeeOppJWT',
    })
  );

export default feathersClient;
